import {
  getInterestsQueryOptions,
  getInterestQueryOptions,
  getInterestsByAdPlatformQueryOptions
} from "../../queries/interests";
import { getAdPlatformsQueryOptions } from "../../queries/adPlatforms";
import { getAdAccountsQueryOptions } from "../../queries/adAccounts";
import { getInterestGroupsQueryOptions } from "../../queries/interestGroups";
import { getLanguagesQueryOptions } from "../../queries/languages";

// necessary entities are pre-fetched when a user hover a 'create interest' or a 'edit interest' link
export const interestFormLoader = ({ context: { queryClient } }) => {
  queryClient.ensureQueryData(getAdPlatformsQueryOptions());
  queryClient.ensureQueryData(getAdAccountsQueryOptions());
  queryClient.ensureQueryData(getInterestGroupsQueryOptions());
  queryClient.ensureQueryData(getLanguagesQueryOptions());
};

// interests are pre-fetched when a user hover a 'interests' link
export const interestListLoader = ({ context: { queryClient } }) => {
  queryClient.ensureQueryData(getInterestsQueryOptions());
};

// interests are pre-fetched when a user hover a 'interests' link within a adPlatform
export const interestListByAdPlatformLoader = ({
  params,
  context: { queryClient },
}) => {
  const { adPlatformId } = params;
  queryClient.ensureQueryData(
    getInterestsByAdPlatformQueryOptions(adPlatformId, queryClient)
  );
};

// interest is pre-fetched when a user hover a 'view interest' link
export const interestViewLoader = ({ params, context: { queryClient } }) => {
  const { interestId } = params;
  queryClient.ensureQueryData(getInterestQueryOptions(interestId, queryClient));
};
